var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.805 5.886c2.397 0 4.195 1.543 4.195 4.859v6.19h-3.644v-5.776c0-1.45-.527-2.44-1.846-2.44-1.007 0-1.606.667-1.87 1.311-.096.231-.12.553-.12.876v6.029H5.876v-.172c.004-.584.013-2.581.018-4.695l.001-.606.001-.605.001-.599V8.837c0-1.343-.007-2.4-.02-2.697H9.52v1.529c.484-.735 1.35-1.783 3.285-1.783Zm-8.946.253v10.796H.215V6.139H3.86ZM2.061.935c1.247 0 2.015.806 2.038 1.865 0 1.036-.791 1.866-2.062 1.866h-.023C.791 4.666 0 3.836 0 2.8 0 1.74.815.935 2.061.935Z",
    fill: "currentcolor",
    fillRule: "nonzero"
  })));
};

export default SvgLinkedin;